import React, { useState } from "react";
import * as Sentry from "@sentry/react";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { useDispatch } from "react-redux";
import ModalComponent from "../Modals/Modal";
import { useNavigate } from "react-router";
import { bookingIfCardNotSaved } from "../../store/actions/paymentActions";
import { useToaster } from "../../components/Toaster/Toaster";

const CARD_OPTIONS = {
  iconStyle: "solid",
  hidePostalCode: false,
  style: {
    base: {
      iconColor: "#7876A1",
      color: "#373559",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "20px",
      fontFamily: "Instrument Sans, Roboto, Open Sans, Segoe UI, sans-serif",
      fontSmoothing: "antialiased",
      ":-webkit-autofill": { color: "#373559" },
      "::placeholder": { color: "#373559" },
    },
    invalid: {
      iconColor: "#c23b22",
      color: "#c23b22",
    },
  },
};

const PaymentForm = ({

  submitWrapper,
  handleCloseCardModal,
  handleShowCardAddedModal,
  handleShowBookingErrorModal,
  onCardChange,
}) => {
  // stripe setup
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();
  const { showToast } = useToaster();
  const [isCardFocused, setIsCardFocused] = useState(false);
  const [modalFields, setModalFields] = useState({
    open: false,
    text: "",
    btnText1: "Ok",
    closeFunc: () => {
      setModalFields({ ...modalFields, open: false });
    },
  });

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const { error, token } = await stripe.createToken(
        elements.getElement(CardElement)
      );

      if (!error) {
        const { id } = token;
        dispatch(
          bookingIfCardNotSaved(
            id,
            modalFields,
            setModalFields,
            () => {}, // setShowLottie noop - keep signature stable
            handleCloseCardModal,
            handleShowCardAddedModal,
            handleShowBookingErrorModal,
            3
          )
        );
        elements.getElement(CardElement).clear();
      } else {
        console.log("payment error", error.message);
        try {
          showToast({ type: "error", message: error.message || "Failed to add card" });
        } catch (e) {
          console.log(e);
        }

      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
      try {
        showToast({ type: "error", message: error.message || "Something went wrong" });
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <div>
      <ModalComponent
        text={modalFields.text}
        openState={modalFields.open}
        closeFunction={() => {
          setModalFields({ ...modalFields, open: false });
        }}
        btnText1={modalFields.btnText1}
        btnClickFunc1={modalFields.closeFunc}
      />
      <form
        id="payment-in-booking"
        onSubmit={(e) =>
          submitWrapper ? submitWrapper(handleSubmit, e) : handleSubmit(e)
        }
      >
        <fieldset>
          <div
            className={`h-12 w-full rounded-[14px] bg-[#E6E6E6] border px-4 flex items-center ${
              isCardFocused ? "border-[#7876A1]" : "border-transparent"
            }`}
          >
            <CardElement
              className="w-full"
              options={CARD_OPTIONS}
              onFocus={() => setIsCardFocused(true)}
              onBlur={() => setIsCardFocused(false)}
              onChange={(e) => onCardChange && onCardChange(e)}
            />
          </div>
        </fieldset>
        {/* <input type="submit" value="save card"></input> */}
      </form>
    </div>
  );
};

export default PaymentForm;
